import request from '../utils/request';

export default {
  djxxWh(params) {
    return request.put('https://192.168.0.7:8443/api/hjzx/newywsl/whdjxx', params);
  },
  queryCzygdxxList(params) {
    return request.get('https://192.168.0.7:8443/api/ywcl/czygd', params);
  },
};



// WEBPACK FOOTER //
// ./src/api/khdzgx.api.js